import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Bike } from './bikeCatalogTypes'
import { getAllBikes } from './bikeCatalogActions'

export interface BikeCatalogState {
  allBikes: Bike[] | null
}

const initialState: BikeCatalogState = {
  allBikes: null,
}

const bikeCatalogSlice = createSlice({
  name: 'bikeCatalog',
  initialState,
  reducers: {
    getAllBikesSuccess(state, action: PayloadAction<Bike[]>) {
      state.allBikes = action.payload || []
    },
  },
})

export const bikeCatalogActions = {
  ...bikeCatalogSlice.actions,
  getAllBikes,
}

export const bikeCatalogReducer = bikeCatalogSlice.reducer
